
import React from 'react';
import { Lock } from 'lucide-react';

interface MemberContactInfoProps {
  canView: boolean;
  phone: string;
  email: string | null;
  isAdmin?: boolean;
}

const MemberContactInfo = ({ canView, phone, email, isAdmin }: MemberContactInfoProps) => {
  // Users can view contact info if:
  // 1. They are admins
  // 2. The canView prop is true (e.g., they are friends with the member)
  const shouldShowContact = canView || isAdmin;
  
  if (shouldShowContact) {
    return (
      <div className="flex flex-col gap-1">
        <span className="text-xs">{phone}</span>
        {email && (
          <span className="text-xs text-gray-500">{email}</span>
        )}
      </div>
    );
  }
  
  return (
    <div className="flex flex-col items-center text-xs text-gray-400">
      <Lock size={16} className="mb-1" />
      <span>Private contact</span>
    </div>
  );
};

export default MemberContactInfo;
